import { render, staticRenderFns } from "./DesignListSidebarMenu.vue?vue&type=template&id=4ee2030d&scoped=true&"
import script from "./DesignListSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./DesignListSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./DesignListSidebarMenu.vue?vue&type=style&index=0&id=4ee2030d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee2030d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ee2030d')) {
      api.createRecord('4ee2030d', component.options)
    } else {
      api.reload('4ee2030d', component.options)
    }
    module.hot.accept("./DesignListSidebarMenu.vue?vue&type=template&id=4ee2030d&scoped=true&", function () {
      api.rerender('4ee2030d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/DesignListSidebarMenu.vue"
export default component.exports